import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Monogram from "./Monogram";

export default function Preloader({ onDone }) {
  const [show, setShow] = useState(true);

  useEffect(() => {
    const t1 = setTimeout(() => setShow(false), 1750);
    const t2 = setTimeout(() => onDone?.(), 1800);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, [onDone]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className="preloader"
          data-testid="preloader"
          exit={{ y: "-100%" }}
          transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.94 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          >
            <div className="preloader-mono">
              <Monogram size={52} />
            </div>
            <div className="preloader-names serif">
              Divyanshi <span>&amp;</span> Divyashiv
            </div>
            <div className="preloader-date kicker">26 · 11 · 2026</div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
